import searchWrap from './components/search-wrap'
import areaWrap from './components/area-wrap'
import { transformDistrictLevelToId } from './utils'
import './style/kye-address.scss'
export default {
  name: 'KyeAddress',
  reportName: 'kye-address',
  components: { searchWrap, areaWrap },
  props: {
    areaName: String,
    areaId: String,
    // addressId: String,
    addressName: String,
    labelData: {
      type: Object,
      default: () => ({})
    },
    areaAttrs: {
      type: Object,
      default: () => ({})
    },
    searchAttrs: {
      type: Object,
      default: () => ({})
    },
    validateData: {
      type: Object,
      default: () => ({
        areaRequire: false,
        addressRequire: false,
        areaError: '请选择区域',
        addressError: '请输入详细地址'
      })
    },
    disabled: String,
    beforeConfirm: Function,
    inline: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      selectAreaData: {},
      addressSearchData: {},
      currentAreaId: '',
      searchValueData: '',
      region: '',
    }
  },
  watch: {
    areaId: {
      immediate: true,
      handler(val) {
        this.changeCurrentAreaId(val)
        const addressIdKey = this.getAddressIdKey()
        this.changeAddressSearchKeyValue(addressIdKey, val)
      }
    },
    addressName: {
      immediate: true,
      handler(val) {
        this.changeSearchValueData(val)
        this.changeAddressSearchKeyValue('title', val)
      }
    }
  },
  render(h) {
    const { $props } = this
    const { areaName, searchAttrs, labelData: propsLabelData, areaAttrs, validateData, disabled, inline } = $props
    const labelData = {
      labelWidth: !inline && !propsLabelData.labelWidth ? '60' : propsLabelData.labelWidth,
      ...propsLabelData
    }
    const defaultAreaProps = {
      labelData: labelData,
      validateData: validateData,
      areaProps: {
        confirmInWatch: true,
        selectFullLevel: true,
        level: 4,
        areaName: areaName,
        areaId: this.currentAreaId,
        ...areaAttrs,
      }
    }
    if (disabled === 'area' || disabled === 'all') {
      defaultAreaProps.areaProps.disabled = true
    }
    const areaWrapBind = {
      props: defaultAreaProps,
      ref: 'kyeAddressAreaWrap',
      on: {
        confirm: this.areaConfirm,
        areaItemClick: this.areaItemClick,
        areaPanelChange: this.areaPanelChange,
        areaClear: this.areaClear
      }
    }
    const defaultSearchProps = {
      labelData: labelData,
      validateData: validateData,
      searchProps: {
        region: this.region,
        value: this.searchValueData,
        clearable: true,
        ...searchAttrs,
      },
    }
    if (disabled === 'address' || disabled === 'all') {
      if (!defaultSearchProps.searchProps.autocompleteAttrs) {
        defaultSearchProps.searchProps.autocompleteAttrs = {}
      }
      defaultSearchProps.searchProps.autocompleteAttrs = {
        ...defaultSearchProps.searchProps.autocompleteAttrs,
        disabled: true
      }
    }
    if (defaultSearchProps.searchProps.autocompleteAttrs) {
      if (defaultSearchProps.searchProps.autocompleteAttrs.hasOwnProperty('clearable')) {
        defaultSearchProps.searchProps.clearable = defaultSearchProps.searchProps.autocompleteAttrs.clearable
      }
    }
    const searchWrapBind = {
      props: defaultSearchProps,
      ref: 'kyeAddressSearchWrap',
      on: {
        select: this.searchSelect,
        blur: this.searchBlur,
        searchInput: this.searchInput,
        clear: this.searchClear,
        focus: this.searchFocus,
        mouseenter: this.searchMouseenter,
        mouseleave: this.searchMouseleave,
        change: this.searchChange
      },
    }
    const renderArea = () => {
      return <area-wrap {...areaWrapBind}></area-wrap>
    }
    const renderSearch = () => {
      return <search-wrap {...searchWrapBind }></search-wrap>
    }
    const contentArea = renderArea()
    const contentSearch = renderSearch()
    const classMap = {
      'kye-address': true,
      'kye-address-inline': inline,
      'kye-address-column': !inline,
    }
    return <div class={classMap} ref="kyeAreaAddress">
      {contentArea}
      {contentSearch}
    </div>
  },
  methods: {
    setCurrentAreaAddressInfo (obj) {
      const { areaId, addressName } = obj || {}
      this.changeCurrentAreaId(areaId)
      this.changeSearchValueData(addressName)
      const addressIdKey = this.getAddressIdKey()
      this.changeAddressSearchKeyValue(addressIdKey, areaId)
      this.changeAddressSearchKeyValue('title', addressName)
    },
    changeSearchValueData (val) {
      this.searchValueData = val
    },
    changeCurrentAreaId (val) {
      this.currentAreaId = val
    },
    changeSelectAreaData (data) {
      this.selectAreaData = data
    },
    changeAddressSearchData (data) {
      this.addressSearchData = data
    },
    changeAddressSearchKeyValue (key, val) {
      this.addressSearchData[key] = val
    },
    areaConfirm (data, isRepeated) {
      console.log('areaConfirm', data)
      if (data) {
        this.changeSelectAreaData(data)
        this.setAddressQuery()
        this.handAreaAddressData(true)
        if (isRepeated) {
          return
        }
      } else {
        this.clearAddressData()
        this.$refs.kyeAddressAreaWrap.clearCurrentAreaId()
      }
      this.changeCurrentAreaId(data ? data.areaId : '')
      this.$emit('areaChange', data)
      this.handeResult()
    },
    areaItemClick (data) {
      this.$emit('areaItemClick', data)
    },
    areaClear () {
      this.$emit('areaClear')
    },
    areaPanelChange (data) {
      this.$emit('areaPanelChange', data)
    },
    searchSelect(data) {
      this.changeAddressSearchData(data)
      // 执行判断数据
      this.$emit('searchChange', data)
      const { areaId, level } = this.selectAreaData
      const areaLevelName = this.getAddressIdKey(level)
      const addressAreaId = this.addressSearchData[areaLevelName]

      const preSearchValueData = this.searchValueData
      this.changeSearchValueData(data.title)
      if (addressAreaId && addressAreaId !== areaId) {
        // 左右两边的 id 如果不相等，替换左边区域数据
        this.changeCurrentAreaId(addressAreaId)
      } else {
        if (preSearchValueData !== data.title) {
          this.handeResult()
        }
      }
    },
    searchBlur() {
      this.$emit('searchBlur')
    },
    searchFocus() {
      this.$emit('searchFocus')
    },
    searchInput(data) {
      this.$emit('searchInput', data)
    },
    searchMouseenter() {
      this.$emit('searchMouseenter')
    },
    searchMouseleave() {
      this.$emit('searchMouseleave')
    },
    handeResult () {
      const { areaId, areaName, areaFullName } = this.selectAreaData || {}
      const addressSearchData = this.addressSearchData
      const { title } = addressSearchData
      const fullName = areaFullName && title ? (areaFullName + title) : undefined
      const data = {
        fullAddress: fullName,
        areaId: areaId,
        areaName: areaName,
        addressName: title,
        areaData: {...this.selectAreaData},
        addressSearchData
      }
      console.log('选择完成', data)
      let beforeConfirm = this.$props.beforeConfirm
      const confirmIter = (res) => this.$emit('confirm', res)
      if (typeof beforeConfirm === 'function') {
        const result = beforeConfirm(data)
        if (result.then) {
          result.then(val => {
            confirmIter(val)
          })
        } else {
          confirmIter(result)
        }
      } else {
        confirmIter(data)
      }
    },
    getAddressIdKey (level) {
      const addressLevel = level || this.areaAttrs.level || 4
      const areaLevelName = transformDistrictLevelToId(addressLevel)
      return areaLevelName
    },
    handAreaAddressData(type) {
      const { areaId, level } = this.selectAreaData
      const areaLevelName = this.getAddressIdKey(level)
      const addressAreaId = this.addressSearchData[areaLevelName]
      if (type) {
        if (this.addressSearchData.hasOwnProperty(areaLevelName) && addressAreaId !== areaId) {
          // 左右两边的 id 如果不相等，清空右边地址数据
          this.clearAddressData()
        }
      } else {
        if (addressAreaId && addressAreaId !== areaId) {
          // 左右两边的 id 如果不相等，替换左边区域数据
          this.changeCurrentAreaId(addressAreaId)
        } else {
          this.handeResult()
        }
      }
    },
    // 清空地址数据
    clearAddressData() {
      this.$refs.kyeAddressSearchWrap.$refs.kyeAddressSearch.clear()
      this.changeAddressSearchData({})
      this.changeSearchValueData('')
      this.changeSelectAreaData({})
    },
    searchClear() {
      this.changeSearchValueData('')
      this.$emit('searchClear')
    },
    searchChange (val) {
      this.$emit('searchChange', val)
    },
    setAddressQuery() {
      const { cityType, zone, city } = this.selectAreaData
      let cityName = ''
      if (cityType === '3') {
        cityName = zone
      } else {
        cityName = city
      }
      this.region = cityName
    },
    async validate(callBack) {
      let callBackResult = null
      if (callBack) {
        if (typeof callBack === 'function') {
          callBackResult = await callBack()
        } else {
          callBackResult = callBack
        }
      }
      let validateArea = false
      let validateAddress = false
      if (this.validateData.areaRequire) {
        const customValidate = callBackResult && callBackResult.area
        validateArea = this.$refs.kyeAddressAreaWrap.validate(customValidate ? callBackResult.area : this.currentAreaId, customValidate)
        if (!validateArea) {
          return false
        }
      }
      if (this.validateData.addressRequire) {
        const customValidate = callBackResult && callBackResult.address
        validateAddress = this.$refs.kyeAddressSearchWrap.validate(customValidate ? callBackResult.address : this.searchValueData, customValidate)
      }
      return validateAddress
    },
    // 清空规则
    clearValidate () {
      this.$refs.kyeAddressAreaWrap.clearValidate()
      this.$refs.kyeAddressSearchWrap.clearValidate()
    }
  }
}






// WEBPACK FOOTER //
// ./src/public/components/kye-address/address.js